import React, { useEffect, useState } from "react";
import { ReactTitle } from "react-meta-tags";
import Modal from "../../../utils/customModal";
import * as instanceActions from "../../../../Redux/api";
import TableAdmissions from "../../../shared/admissions/table";
import ChangesUserDetail from "../../../shared/user/edit/detail";
import * as UserAction from "../../../../Redux/actions/userActions";
import {
  getPendingUsers,
  getTotalPendingUsers,
} from "../../../../Redux/reducer/users";
import {
  loadingHtml,
  errorContainer,
  sucessInfoModal,
  enableScroll,
} from "../../../utils/functions";

import noAproval from "../../../../../static/images/add-client-bsc.svg";
import ActionMenuList from "canvas-core-react/lib/ActionMenuList";
import ActionMenuListItem from "canvas-core-react/lib/ActionMenuListItem";
import IconShow from "canvas-core-react/lib/IconShow";

import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getFilters } from "../../../utils/utilities";

const filters = getFilters([
  { name: "identification", property: "identification", operator: "eq" },
]);

const defaultUser = {
  userCode: null,
  businessId: null,
  userType: null,
  country: null,
};

const UserApprovalsComponent = ({ setFilters }) => {
  const [state, setState] = useState({
    validUsers: [],
    page: 0,
    sizePerPage: 10,
    contentReady: false,
    pendingList: true,
    showDetail: false,
    menus: [],
  });

  const [selectedUser, setSelectedUser] = useState(defaultUser);

  const [modal, setModal] = useState({
    show: false,
    content: null,
    onClose: undefined,
    showClose: false,
  });

  const { pending, total } = useSelector((state) => ({
    pending: getPendingUsers(state),
    total: getTotalPendingUsers(state),
  }));

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const {
    headers,
    detailMsg,
    userTypeLabel,
    statesLabel,
    pageTitle,
    modalMsg,
    continueMsg,
  } = {
    headers: t("general.headers", { returnObjects: true }),
    detailMsg: t("detail"),
    userTypeLabel: t("userType", { returnObjects: true }),
    statesLabel: t("general.states", { returnObjects: true }),
    pageTitle: t("admissions.tabs.users"),
    modalMsg: t("general.modal.success"),
    continueMsg: t("general.buttons.continue", { returnObjects: true }),
  };

  useEffect(() => {
    setFilters({ filters, search: getSearchResult });
    pendingForApprovals();

    return () => {
      setFilters({ filters: undefined, search: undefined });
    };
  }, []);

  const pendingForApprovals = async () => {
    setState((prev) => ({ ...prev, contentReady: false }));
    await dispatch(UserAction.getPendingUsers());
    setState((prev) => ({ ...prev, contentReady: true }));
  };

  const getSearchResult = (property, value = "") => {
    let actionFilters = [];
    const cleanValue = value.trim();

    if (cleanValue !== "") {
      // Realizamos la busqueda por filtros
      let operator = "";
      filters.map((item) => {
        if (item.property == property) {
          operator = item.operator;
        }
      });
      actionFilters = [
        { property: property, operator: operator, value: cleanValue },
      ];
    }

    handlerTableChange({
      page: 0,
      sizePerPage: state.sizePerPage,
      customFilters: actionFilters,
    });
  };

  const getAuthorizedData = () => {
    return pending.map((item) => {
      return {
        userCode: item.institutions ? (
          <a
            title="Ver cambios"
            className={"admission-p record"}
            onClick={() =>
              toogleListDetail({
                userCode: item.codUser,
                businessId: item.institutions[0].businessId,
                userType: item.userType.code,
                country: item.institutions[0].country.code,
              })
            }
          >
            {item.codUser}
          </a>
        ) : (
          item.codUser
        ),
        name: `${item.firstName} ${item.lastName}`,
        identification: item.identification,
        id: item.id,
        status: getStatusLbl(item.status),
        company: item.institutions ? item.institutions[0].companyName : "N/A",
        userType: getUserType(item.userType.code),
        item,
      };
    });
  };

  const getTableColumns = () => {
    return [
      { grow: 2, selector: "userCode", name: headers.userCode },
      { grow: 2, selector: "name", name: headers.userName },
      { grow: 2, selector: "identification", name: headers.id },
      { grow: 2, selector: "company", name: headers.company },
      { grow: 2, selector: "userType", name: headers.userType },
      { grow: 2, selector: "status", name: headers.state, center: true },
      {
        grow: 2,
        selector: "actions",
        name: headers.actions,
        center: true,
        cellFormatter: (row) => getHeaderAction(row.item),
      },
    ];
  };

  const handleMenu = (id, open) => {
    const { menus } = state;
    menus[`menu-${id}`] = open;
    setState((prev) => ({ ...prev, menus }));
  };

  const getHeaderAction = (item) => {
    const { menus } = state;
    return item.institutions ? (
      <ActionMenuList
        dialogPosition="bottom-right"
        iconType="horizontal-small"
        bottomSheet={{
          heading: "Actions",
          secondaryAction: {
            onClick: () => {},
            label: "Cancel",
          },
        }}
        isMenuOpen={menus[`menu-${item.id}`] || false}
        setIsMenuOpen={(open) => handleMenu(item.id, open)}
      >
        <ActionMenuListItem
          icon={() => (
            <IconShow
              id={`user-approval-${item.id}`}
              className="TextButton__icon--left"
            />
          )}
          onClick={() => {
            enableScroll();
            loadUserTemp(item);
          }}
        >
          {detailMsg}
        </ActionMenuListItem>
      </ActionMenuList>
    ) : null;
  };

  const loadUserTemp = (item) => {
    const { menus } = state;
    menus[`menu-${item.id}`] = false;
    setState((prev) => ({ ...prev, menus }));
    toogleListDetail({
      userCode: item.codUser,
      businessId: item.institutions[0].businessId,
      userType: item.userType.code,
      country: item.institutions[0].country.code,
    });
  };

  const getUserType = (userType) => {
    return userType === "PRO" ? userTypeLabel.provider : userTypeLabel.client;
  };

  const getStatusLbl = (status) => {
    return (
      <span className="StatusBadge__span pending-client">
        {status === "TRANSITORY"
          ? statesLabel.PENDING
          : statesLabel.PENDING_CHANGES}
      </span>
    );
  };

  const closeModal = () => {
    setModal({
      show: false,
      content: null,
      onClose: undefined,
      showClose: false,
    });
  };

  const finishAdmission = () => {
    const buttons = {
      SelBtn: {
        text: continueMsg,
        action: closeModal,
      },
    };

    const content = sucessInfoModal(pageTitle, modalMsg, buttons);
    setModal({ content, show: true, showClose: true, onClose: closeModal });
  };

  const submitApprovals = async (approve, elements) => {
    setModal((prev) => ({ ...prev, show: true, content: loadingHtml() }));
    let updateStates = [];

    Object.keys(elements).map((key) => {
      const idUsers = key.split("-")[1];
      updateStates.push({
        idUser: idUsers,
        active: approve,
      });

      return true;
    });

    try {
      await dispatch(
        instanceActions.instanceAction("/users/approve-or-rejected", "put", {
          users: updateStates,
        })
      );

      finishAdmission();
      pendingForApprovals();
    } catch (err) {
      let content;
      if (
        err.response !== undefined &&
        Array.isArray(err.response.data.notifications)
      ) {
        const notification = err.response.data.notifications[0];
        content = errorContainer(
          notification.message,
          notification.description
        );
      }

      setModal((prev) => ({
        ...prev,
        content,
        onClose: closeModal,
        showClose: true,
      }));
      pendingForApprovals();
    }
  };

  const handlerTableChange = async ({
    page,
    sizePerPage,
    customFilters = [],
  }) => {
    await dispatch(
      UserAction.getPendingUsers(page, sizePerPage, customFilters)
    );
    setState((prev) => ({ ...prev, page, sizePerPage }));
  };

  const toogleListDetail = (user = defaultUser, refress) => {
    setState((prev) => ({
      ...prev,
      pendingList: !prev.pendingList,
      showDetail: !prev.showDetail,
      menus: [],
    }));

    setSelectedUser(user);

    if (refress) pendingForApprovals();
  };

  const { contentReady, sizePerPage, page, pendingList, showDetail } = state;

  const data = getAuthorizedData();

  return (
    <>
      <ReactTitle title={`${pageTitle} - Reverse Factoring`} />
      {contentReady ? (
        pending.length > 0 ? (
          pendingList === true && (
            <>
              <TableAdmissions
                headers={getTableColumns()}
                data={data}
                page={page}
                addmissionType={`user`}
                sizePerPage={sizePerPage}
                totalSize={total}
                onTableChange={handlerTableChange}
                submitAdmissions={submitApprovals}
              />
            </>
          )
        ) : (
          <div id="blankAprrovals">
            <img src={noAproval} className="clientImage" />
            <p>{t("admissions.noData")}</p>
            <div className="line-aproval"></div>
          </div>
        )
      ) : (
        <div className="loader innner"></div>
      )}
      {true === showDetail && (
        <ChangesUserDetail
          user={selectedUser}
          goBack={(value) => toogleListDetail({}, value)}
        />
      )}
      <Modal
        show={modal.show}
        handleClose={modal.onClose}
        showClose={modal.showClose}
      >
        {modal.content}
      </Modal>
    </>
  );
};

export default UserApprovalsComponent;
